<template>
  <div class="default-table" v-if="userPermissions.indexOf('kol_resource_list') !== -1">
    <tableSearch :searchCondition.sync="searchCondition" :typePlatform="'douyin'"
                 @handleQuery="handleQuery"></tableSearch>

    <el-row>
      <el-button @click="handleAdd('add')" type="primary"
                 v-if="userPermissions.indexOf('kol_info_save') !== -1">添加红人
      </el-button>
      <div class="update download" v-if="userPermissions.indexOf('kol_info_excel') !== -1">
        <el-upload
          :before-upload="beforeUpload"
          :disabled="loadingUpload"
          :file-list="file"
          ref="upload"
          :auto-upload="false"
          :data="{http_id:httpId}"
          :headers="uploadHeaders"
          :on-change="handleChange"
          :on-success="importSuccess"
          :show-file-list="false"
          action="/admin_api/kol_info/import"
          class="upload-demo"
          multiple
        >
          <el-button :icon="`${loadingUpload?'el-icon-loading':'el-icon-upload2'}`"
                     :loading="loadingUpload"
                     size="mini" type="primary">批量导入
          </el-button>

        </el-upload>
      </div>
      <export-btn :can-export="userPermissions.indexOf('kol_info_excel') !== -1"
                  :lintTitle="'下载模板'"
                  @export="downLoad"
                  class="download"
                  ref="refExportLink"/>
      <el-button @click="uploadFile" type="primary" class="ml-10"
                 v-if="userPermissions.indexOf('kol_info_excel') !== -1">导入记录
      </el-button>
    </el-row>

    <br/>
    <br/>
    <el-table :data="tableData" @selection-change="handleSelectionChange" ref="multipleTable" row-key="id"
              border v-loading="loadingStatus">
      <el-table-column :reserve-selection="true" type="selection" width="55"></el-table-column>
      <el-table-column align="center" label="序号" type="index" width="80">
      </el-table-column>
      <el-table-column align="center" label="红人昵称" min-width="150" prop="kol_info.nickname"
                       show-overflow-tooltip>
        <template slot-scope="{ row }">
          <el-link @click="detailPage(row.kol_id)" size="mini" type="primary"
                   v-if="userPermissions.indexOf('kol_info_item') !== -1">
            <span>{{ row.kol_info.nickname }} </span>
          </el-link>
        </template>
      </el-table-column>
      <el-table-column align="center" label="个人/机构(名称)" min-width="120px"
                       prop="kol_info.organ_name"></el-table-column>
      <el-table-column align="center" label="媒介" prop="kol_info.referrer"></el-table-column>
      <el-table-column align="center" label="资源来源" min-width="100" prop="kol_info.source"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center" label="账号标签" min-width="100" prop="kol_info.account_label"
                       show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span>{{ row.kol_info.account_label ? row.kol_info.account_label.toString() : '' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="性别" width="50">
        <template slot-scope="{ row }">
          <span>{{ row.kol_info.sex == '1' ? '男' : row.kol_info.sex == '2' ? '女' : '其他' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="肤质" min-width="100" prop="kol_info.skin_type"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center" label="链接" min-width="100" prop="home_page_link"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center" label="粉丝量(W)" min-width="100" prop="fans_total"></el-table-column>
      <el-table-column align="center" label="赞藏数(W)" min-width="100" prop="like_total"></el-table-column>
      <el-table-column align="center" label="星图价格">
        <el-table-column align="right" label="20s" prop="price_json.opened_star_price.20s" width="130">
          <template slot-scope="scope">
            <span> {{
              scope.row.price_json.opened_star_price ? moneyFormat(scope.row.price_json.opened_star_price['20s']) : 0
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="right" label="60s" prop="price_json.opened_star_price.60s" width="130">
          <template slot-scope="scope">
            <span> {{
              scope.row.price_json.opened_star_price ? moneyFormat(scope.row.price_json.opened_star_price['60s']) : 0
            }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column align="center" label="非星图价格">
        <el-table-column align="right" label="单推" width="130">
          <template slot-scope="scope">
            <span> {{
              scope.row.price_json.not_opened_star_price ? moneyFormat(scope.row.price_json.not_opened_star_price.single) : 0
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="right" label="合集" width="130">
          <template slot-scope="scope">
            <span> {{
              scope.row.price_json.not_opened_star_price ? moneyFormat(scope.row.price_json.not_opened_star_price.union) : 0
            }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column align="center" label="数据近30天">
        <el-table-column align="center" label="平均播放量w" prop="month_play_total" width="130"></el-table-column>
        <el-table-column align="center" label="平均点赞w" prop="month_zan_total" width="130"></el-table-column>
      </el-table-column>
      <el-table-column align="center" label="粉丝画像">
        <el-table-column align="center" label="性别" prop="kol_info?.fans_info[0].sex" width="80">
          <template slot-scope="{ row }">
            <span>{{
                row.kol_info?.fans_info?.[0].sex == '1' ? '男' : row.kol_info?.fans_info?.[0].sex == '' ? '' : '女'
            }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="比例%" prop="kol_info?.fans_info[0].rate" width="80"></el-table-column>
        <el-table-column align="center" label="人群标签TOP" prop="kol_info?.fans_info[0].label" show-overflow-tooltip
                         width="120">
          <template slot-scope="{ row }">
            <span>{{ row.kol_info?.fans_info?.[0].label ? row.kol_info?.fans_info?.[0].label.toString() : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="主要年龄" prop="kol_info.fans_info?.[0].master_age" show-overflow-tooltip
                         width="80">
          <template slot-scope="{ row }">
            <span>{{
                row.kol_info?.fans_info?.[0].master_age ? row.kol_info?.fans_info?.[0].master_age.toString() : ''
            }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column align="center" label="过往合作品牌" min-width="120" prop="kol_info.co_brand"
                       show-overflow-tooltip></el-table-column>
      <el-table-column align="center" label="配合度" prop="kol_info.fit" width="80"></el-table-column>
      <el-table-column align="center" label="联系方式" prop="kol_info.contact_mode.value" show-overflow-tooltip
                       width="150">
        <template slot-scope="{ row }">
          <span
          >{{
            row.kol_info.contact_mode.mode == '' ? '' : row.kol_info.contact_mode.mode == 'mobile' ? '手机：' : '微信：'
          }}{{ row.kol_info.contact_mode.value ? row.kol_info.contact_mode.value : '暂无' }}</span
          >
        </template>
      </el-table-column>
      <el-table-column align="center" label="备注" prop="remark" show-overflow-tooltip width="120"></el-table-column>
      <el-table-column align="center" label="最后更新时间" prop="kol_info.updated_at" show-overflow-tooltip
                       width="100"></el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24" class="text-right">
        <Pagination :limit.sync="pagingData.page_size" :page.sync="pagingData.current_page" :total="pagingData.total"
                    @pagination="getList"/>
      </el-col>
    </el-row>
    <el-row>
      <h3>当前已选红人：<span style="color: #ff3176;font-style:italic ">{{ this.selectIds.length }}</span> 人</h3>
    </el-row>
    批量操作：
    <el-button @click="handleBtn" type="primary" v-if="userPermissions.indexOf('kol_resource_item') !== -1">
      添加提报
    </el-button>
    <el-button @click="clearSelect" style="margin-top: 12px" type="primary">清空选择</el-button>
    <div class="trolley" @click="handleBtn">
      <svg t="1672295021682" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
           p-id="4419" width="60" height="60">
        <path
          d="M330.54 931.58c-39.53 0-71.7-32.16-71.7-71.69s32.16-71.7 71.7-71.7c25.53 0 49.32 13.74 62.09 35.85 12.77 22.11 12.77 49.58 0 71.7-12.77 22.1-36.56 35.84-62.09 35.84z m0-100.21c-15.72 0-28.51 12.79-28.51 28.51 0 15.72 12.79 28.51 28.51 28.51 10.15 0 19.61-5.46 24.69-14.25 5.07-8.79 5.07-19.72 0-28.51-5.08-8.8-14.54-14.26-24.69-14.26z m429.98 100.2c-0.52 0-1.05-0.01-1.57-0.02-38.65-0.86-70.1-33.01-70.12-71.66-0.01-38.66 31.42-70.83 70.08-71.7 25.95-0.5 50.27 12.96 63.43 35.35 13.15 22.39 13.16 50.22 0.02 72.62-12.88 21.95-36.46 35.4-61.84 35.41z m-0.63-100.21c-15.37 0.35-27.87 13.14-27.87 28.51 0 15.38 12.52 28.16 27.88 28.5 10.34 0.32 19.99-5.16 25.22-14.08 5.22-8.9 5.22-19.97-0.01-28.88-5.23-8.89-14.68-14.28-25.22-14.05z m46.91-54.29H263.89c-27.49 0-49.85-21.99-49.85-49.02 0-1.56 0.13-2.9 0.25-3.92v-36.34c0-11.92 9.67-21.59 21.59-21.59s21.59 9.67 21.59 21.59v35.31c0.11 1.25 0.1 2.51-0.01 3.76-0.05 0.6-0.13 1.19-0.2 1.77 0.33 2.95 3.18 5.26 6.63 5.26H806.8c4.51 0 7-9.78 7.27-10.9 2.92-12.16 2.07-32.42-3.39-39.35-0.68-0.86-1.21-1.54-3.88-1.54H342.37c-21.4 0-38.81-17.41-38.81-38.81v-36.72c0-10.36 4.02-20.1 11.33-27.42 7.32-7.34 17.07-11.38 27.44-11.38h0.02c81.55 0.04 411.12 0.06 411.12 0.06 22.51 0 35.26-11.97 38.96-36.61 0.04-0.27 0.08-0.53 0.14-0.8 0.25-1.35 25.5-135.12 33.39-179.49 1.81-10.21-1.57-14.19-2.68-15.5-3.05-3.6-13.99-11.89-47.78-11.51h-0.26c-11.8 0-21.44-9.5-21.59-21.33-0.14-11.92 9.41-21.7 21.33-21.85 38.53-0.48 65.78 8.54 81.23 26.75 11.53 13.6 15.77 31.23 12.26 50.99-7.72 43.41-31.9 171.6-33.4 179.56-6.93 45.01-38.16 72.96-81.6 72.96 0 0-318.38-0.02-406.73-0.06v27.97H806.8c15.45 0 28.52 6.22 37.79 18 18.05 22.9 15.39 59.84 11.46 76.18-6.53 27.13-25.4 43.98-49.25 43.98zM235.88 570.23c-11.92 0-21.59-9.67-21.59-21.59V288.69c0-5.07-4.12-9.19-9.18-9.19h-86.62c-19.7 0.34-39.35-13.27-48.36-33.69-5.35-12.14-11.84-40.99 1.92-63.36 6.41-10.42 19.47-23.11 45.32-24.46 0.37-0.02 0.75-0.03 1.12-0.03h141.26c1.48-0.18 2.79-0.28 4.15-0.28 25.68 0 45.84 16.94 51.37 43.15l0.15 0.77 11.98 69.29a10.7 10.7 0 0 0 10.55 8.91c63.44-0.02 190.76-0.04 302.96-0.05 11.92 0 21.59 9.66 21.59 21.59 0 11.92-9.67 21.59-21.59 21.59-112.19 0.01-239.51 0.03-302.94 0.05h-0.02c-26.28 0-48.61-18.81-53.1-44.73l-11.91-68.85c-1.76-7.87-5.54-8.48-8.35-8.53l-1.25 0.15c-0.75 0.08-1.51 0.12-2.27 0.12H119.1c-5.43 0.35-8.89 1.67-10.28 3.94-3.32 5.39-1.71 17.59 0.81 23.3 2.18 4.94 6.42 7.94 8.53 7.94h86.94c28.88 0 52.37 23.49 52.37 52.37v259.95c0 11.92-9.67 21.59-21.59 21.59z"
          fill="#ff3176"
          p-id="4420"
        ></path>
        <path
          d="M844.14 271.84c12.55-2.67 25.09-5.81 37.75-8.01 7.2-1.16 10.69-4.06 11.85-11.73 1.51-11.38 4.41-22.53 6.74-33.68 0.35-1.97 0.58-3.95 2.55-5.11 2.9 14.29 6.16 28.46 8.83 42.63 0.82 4.29 2.56 5.92 6.74 6.73 13.94 2.79 27.76 6.04 41.59 10.46-13.71 3.02-27.3 6.16-41 8.83-4.53 0.93-6.51 2.56-7.44 7.2-2.56 13.94-5.69 27.88-8.83 42.74-3.95-6.85-3.83-14.17-5.58-20.79-1.98-7.55-3.6-15.21-4.76-23-0.58-4.18-2.67-5.34-6.39-6.15-13.94-2.79-27.88-5.92-41.93-8.94 0-0.25-0.12-0.72-0.12-1.18z"
          fill="#ff3176"
          opacity=".67"
          p-id="4421"
        ></path>
        <path
          d="M80.25 854.62c13.31-2.83 26.62-6.16 40.05-8.5 7.64-1.23 11.34-4.31 12.57-12.44 1.6-12.08 4.68-23.91 7.15-35.73 0.37-2.09 0.61-4.19 2.71-5.42 3.08 15.16 6.53 30.19 9.36 45.22 0.86 4.56 2.71 6.28 7.15 7.14 14.79 2.96 29.45 6.41 44.12 11.09-14.54 3.2-28.96 6.53-43.5 9.36-4.81 0.99-6.9 2.71-7.89 7.64-2.71 14.78-6.04 29.57-9.36 45.34-4.19-7.27-4.07-15.03-5.91-22.06-2.1-8.01-3.82-16.14-5.05-24.4-0.61-4.43-2.83-5.67-6.78-6.53-14.79-2.96-29.57-6.28-44.48-9.49-0.01-0.23-0.14-0.73-0.14-1.22z"
          fill="#ff3176"
          p-id="4422"
        ></path>
        <path
          d="M325.64 167.86c16.17-3.44 32.34-7.48 48.65-10.33 9.28-1.5 13.77-5.24 15.27-15.12 1.95-14.67 5.69-29.04 8.68-43.41 0.45-2.54 0.75-5.09 3.3-6.59 3.74 18.41 7.93 36.67 11.37 54.94 1.05 5.53 3.3 7.63 8.68 8.68 17.97 3.59 35.78 7.78 53.59 13.48-17.67 3.89-35.18 7.93-52.84 11.37-5.84 1.2-8.38 3.3-9.58 9.28-3.3 17.96-7.34 35.93-11.38 55.08-5.09-8.83-4.93-18.26-7.19-26.79-2.54-9.73-4.64-19.61-6.13-29.64-0.75-5.39-3.44-6.88-8.24-7.93-17.96-3.59-35.93-7.63-54.04-11.53-0.14-0.14-0.14-0.74-0.14-1.49z"
          fill="#ff3176"
          opacity=".2"
          p-id="4423"
        ></path>
        <path d="M552.89 577.86m-194.32 0a194.32 194.32 0 1 0 388.64 0 194.32 194.32 0 1 0-388.64 0Z" fill="#ff3176"
              opacity=".2" p-id="4424"></path>
        <path d="M708.35 301.71m-24.6 0a24.6 24.6 0 1 0 49.2 0 24.6 24.6 0 1 0-49.2 0Z" fill="#ff3176"
              p-id="4425"></path>
        <path d="M235.74 620.38m-24.6 0a24.6 24.6 0 1 0 49.2 0 24.6 24.6 0 1 0-49.2 0Z" fill="#ff3176"
              p-id="4426"></path>
      </svg>
    </div>

    <trolleyDrawer :trolleyDrawer.sync="trolleyDrawer" :trolley="selectIds"
                   @handleBtn="handleBtn" @delTrolley="delTrolley"></trolleyDrawer>

    <el-dialog v-if="uploadFileShow" :before-close="handleClose" title="导入记录" :visible.sync="uploadFileShow"
               width="90%">
      <upload-file-list :progressShow="progressShow" :percentage="percentage" :progressTextShow="progressTextShow"
                        :fileName="fileName" :progressText="progressText"
                        :uploadType="'kol_resource'" :reloadData="reloadData"
                        :uploadFileShow="uploadFileShow"></upload-file-list>
    </el-dialog>
  </div>
</template>

<script>
import exportDialog from './components/Dialog'
import { mapGetters } from 'vuex'
import { numberFormat } from '@/utils/utils'
import tableSearch from './components/TableSearch'
import trolleyDrawer from './components/trolleyDrawer'
import ExportBtn from '@/components/export/ExportBtn'
import { getToken } from '@/utils/auth'
import uploadFileList from '@/components/uploadIndex'

export default {
  name: 'KolTiktokResources',
  components: {
    exportDialog,
    tableSearch,
    trolleyDrawer,
    ExportBtn,
    uploadFileList
  },
  computed: {
    ...mapGetters(['userPermissions', 'userInfo'])
  },
  provide() {
    return {
      platformCode: this.platformCode
    }
  },
  data() {
    return {
      platformCode: 'douyin',
      //项目明细数据
      tableData: [],
      selectIds: [],
      dialogVisible: false,
      loadingStatus: true,
      pagingData: {
        page_size: 10,
        current_page: 1,
        total: 0
      },
      kolIds: [],
      searchCondition: {
        nickname: '',
        sex: '',
        organ_name: '',
        referrer: '',
        account_label: '',
        skin_type: '',
        fans_total: {
          range: '=',
          value: ''
        },
        like_total: {
          range: '=',
          value: ''
        },
        co_brand: '',
        fit: ''
      },
      //购物车数据
      trolley: [],
      trolleyDrawer: false,
      idsProp: [],
      file: [],
      uploadHeaders: { 'HYPERF-SESSION-ID': null },
      loadingUpload: false,
      WebSocket: '',
      lockReconnect: false, // 连接状态标识
      reconnectTimeout: 3 * 1000, // websocket重连时间间隔 ms
      httpId: '',
      percentage: 0,
      progressText: '',
      progressShow: false,
      uploadFileShow: false,
      progressTextShow: false,
      wsStop: false,
      fileName: '',
      reloadData:false
    }
  },
  methods: {
    uploadFile() {
      this.uploadFileShow = true
      this.progressShow = false
    },
    delTrolley(row) {
      this.selectIds.splice(this.trolley.indexOf(row), 1)
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    handleAdd(id) {
      this.$router.push({
        name: 'kol_add',
        params: { id: id, type: 'tiktok' }
      })
    },
    handleSearchCondition() {
      const searchData = ['nickname', 'sex', 'organ_name', 'referrer', 'account_label', 'skin_type', 'co_brand', 'fit']
      const cond = {}
      searchData.forEach((item) => {
        this.searchCondition[item] ? (cond[item] = this.searchCondition[item]) : ''
      })
      if (this.searchCondition.fans_total && this.searchCondition.fans_total.value !== '') {
        cond.fans_total = {
          range: this.searchCondition.fans_total.range,
          value: this.searchCondition.fans_total.value
        }
      }
      if (this.searchCondition.like_total && this.searchCondition.like_total.value !== '') {
        cond.fans_total = {
          range: this.searchCondition.like_total.range,
          value: this.searchCondition.like_total.value
        }
      }
      return cond
    },
    async getList() {
      this.loadingStatus = true
      const searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition, {
        page_size: this.pagingData.page_size || 10,
        current_page: this.pagingData.current_page || 1,
        platform_code: 'douyin'
      })
      const { list, page_info } = await this.$api.resourceList(searchCondition)
      this.$nextTick(() => {
        this.tableData = list
        this.pagingData = page_info
        this.loadingStatus = false
      })
    },
    handleSelectionChange(val) {
      this.selectIds = []
      if (val.length > 0) {
        val.forEach((item) => {
          this.selectIds.push(item)
        })
      }
    },

    handleBtn() {
      if (this.selectIds.length > 0) {
        this.trolleyDrawer = true
      } else this.$message.info('请选择提报对象!')
    },
    moneyFormat(value) {
      // 金额 格式化
      return numberFormat(value, 0, '.', ',', 'round')
    },
    getexportState(val) {
      if (val) {
        this.$refs.multipleTable.clearSelection()
        this.dialogVisible = false
        this.trolleyDrawer = false
        this.trolley = []
      }
    },
    handleQuery() {
      this.pagingData.current_page = 1
      this.getList()
    },
    detailPage(id) {
      this.$router.push({
        name: 'kol_ArtistIntro',
        params: { id: id }
      })
    },
    dialogClose() {
      this.dialogVisible = false
    },
    clearSelect() {
      this.$refs.multipleTable.clearSelection()
    },

    async downLoad() {
      try {
        const isFileSaverSupported = !!new Blob
        if (isFileSaverSupported) {
          // let searchCondition = this.handleSearchCondition()
          const response = await this.$api.exportKolTemplate({ type: 'douyin' })
          const name = `批量导入抖音红人模板`
          this.$refs.refExportLink.exportSaveXlsx(response, name)
        }
      } catch (e) {
        this.$message.warning('浏览器不支持导出文件')
      }
    },
    //导入
    //上传模块
    //上传模块
    handleClose() {
      this.wsStop = false
      this.uploadFileShow = false
      // this.uploadFileShow = true
      this.progressShow = false
          this.reloadData = false

    },
    ws() {
      if (!this.wsStop) {
        let url = ''
        if (process.env.NODE_ENV === 'development')
          url = `${process.env.VUE_APP_WS_URL}/inquiry/import?http_id=${this.httpId}`
        else {
          const wsProtocol = window.location.protocol === 'http:' ? 'ws:' : 'wss:'
          const hostname = window.location.hostname
          url = `${wsProtocol}//${hostname}${process.env.VUE_APP_WS_URL}/inquiry/import?http_id=${this.httpId}`
        }
        this.WebSocket = new WebSocket(url)
        if (url && url.length > 0) {

          this.WebSocket.onopen = () => {
            this.WebSocket.send('open')
            this.$refs.upload.submit()
          }
          this.WebSocket.onmessage = e => {
            this.wsOnMessage(e)
          }
          this.WebSocket.onerror = () => {
            // this.reconnect()
            // this.wsOnError(err)
          }
          this.WebSocket.onclose = () => {
            // alert(this.token)
          }
        } else this.$notify.warning('即时通讯地址为空')

      }
    },

    handleChange(file) {
      this.file = [file]
      this.fileName = this.file[0].name
      this.ws()
      this.wsStop = true
      this.progressShow = true

    },
    importSuccess(response) {
      this.loadingUpload = false
      this.loadingStatus = false
      if (response.code === 200) {
        this.$notify.success(response.data)
        this.submitted = []
        this.showProgress = false
        this.reloadData = true

        this.dataList = response.data.list || []
        this.getList()
      } else {
        this.$notify.warning(response.msg)
      }
    },
    importError() {
      // this.$notify.success('上传失败,请确定')
      // this.submitted = []
      this.loadingUpload = false
      this.loadingStatus = false
      this.showProgress = false
      this.uploadFileShow=false

      // this.dataList = []
      this.wsClose()
    },
    wsClose() {
      if (this.WebSocket && this.WebSocket.readyState === this.WebSocket.OPEN) {
        this.WebSocket.close()
        this.WebSocket = null
      }
    },
    beforeUpload() {
      this.httpId = Math.ceil(Math.random() * 999999999999)
      this.percentage = 0
      this.loadingUpload = true
      this.loadingStatus = true
      this.uploadFileShow = true
      this.uploadHeaders['HYPERF-SESSION-ID'] = getToken()
    },
    wsOnMessage(e) {
      // this.debugLogger('wsOnMessage:', e)
      const str = JSON.parse(e.data)
      if (!str) return
      if (str.type === 'upload' || str.type === 'parse') {
        this.progressTextShow = true
        this.progressText = str.msg
      }

      if (str.type === 'process') {
        this.percentage = str.process
        if (str.process == 100) {
          setTimeout(() => {
            this.progressTextShow = false
          }, 500)
          // this.progressShow = false
          this.wsClose()
        }
      }


    },
    reconnect() {
      if (this.lockReconnect) {
        return
      }
      this.lockReconnect = true
      // 没连接上会一直重连，设置延迟避免请求过多
      // tt && clearTimeout(tt);
      setTimeout(() => {
        this.initWebSocket()
        this.lockReconnect = false
      }, this.reconnectTimeout)
    }

  },
  mounted() {
    this.getList(),
        this.httpId = Math.ceil(Math.random() * 999999999999)

  }
}
</script>


<style scoped>
.table-search {
  margin-top: 10px;
}

.trolley {
  position: relative;
  left: 95%;
  bottom: 20%;
  cursor: pointer;
  width: 60px;
  height: 60px;
}

.trolley:hover {
  transform: rotateZ(-20deg);
}

.transform {
  cursor: pointer;
  margin-left: 10px;
}

.transform:hover {
  color: red;
}

</style>
